export default {"src":"/uk/_next/static/media/supportIcon.835d0d43.svg","height":61,"width":60,"blurWidth":0,"blurHeight":0};